import React from "react";
import ArrowDownIconSvg from "../../../../assets/images/ArrowDownIcon.svg";
import "./ServiceDetailsV2.css";

/** Figma Select arrow — 20×20, text/default fill (#1A354D). */
export function ServiceDetailsSelectArrow() {
  return (
    <img
      src={ArrowDownIconSvg}
      alt=""
      aria-hidden="true"
      width={20}
      height={20}
      className="sdv2-select-arrow"
    />
  );
}

function ServiceDetailsV2({ readOnly = false }) {
  return (
    <div className="lp-v3 sdv2-root">
      <div className="sdv2-heading">Service Details</div>
    </div>
  );
}

export default React.memo(ServiceDetailsV2);
